export function Node(id, range, data, date, startTime, endTime) {
    this.id = id;
    this.range = range;
    this.neighbours = [];
    this.cluster = null;
    this.position = null;
    this.biggestCliqueSize = 1;
    this.data = data;
    this.date = date;
    this.startTime = startTime;
    this.endTime = endTime;
}